<div class="air-details-container">
  <div class="header">OA Details</div>
  <div>
    <div class="section-title">TLR Tag Number: {{ tagNumber }}</div>
    <div class="section-tile error" *ngIf="errors">
      Permanente Repair Date must be less than or equal NAMO Date.
    </div>
    <div class="partioned-table">
      <div class="row">
        <div class="cell label">Repair Type</div>
        <div class="cell value">{{ oaCompilanceDetails["repairType"] }}</div>
      </div>
      <div class="row">
        <div class="cell label">Division</div>
        <div class="cell value">{{ oaCompilanceDetails.division }}</div>
      </div>
      <div class="row">
        <div class="cell label">Section</div>
        <div class="cell value">{{ oaCompilanceDetails.section }}</div>
      </div>
      <div class="row">
        <div class="cell label">Plant</div>
        <div class="cell value">{{ oaCompilanceDetails.plant }}</div>
      </div>
      <div class="row">
        <div class="cell label">TLR Tag No.</div>
        <div class="cell value">{{ oaCompilanceDetails.tagNumber }}</div>
      </div>
      <div class="row">
        <div class="cell label">Rule 1173</div>
        <div class="cell value">{{ oaCompilanceDetails.rule1173 }}</div>
      </div>
      <div class="row">
        <div class="cell label">Leaking From</div>
        <div class="cell value">{{ oaCompilanceDetails.leakingFrom }}</div>
      </div>
      <div class="row">
        <div class="cell label">Operating PSI</div>
        <div class="cell value">{{ oaCompilanceDetails.operatingPSI }}</div>
      </div>
      <div class="row">
        <div class="cell label">Operating Temp</div>
        <div class="cell value">
          {{ oaCompilanceDetails.operatingTemperature }}
        </div>
      </div>
      <div class="row">
        <div class="cell label">Vapor/Liquid</div>
        <div class="cell value">{{ oaCompilanceDetails.materialState }}</div>
      </div>
      <div class="row">
        <div class="cell label">Service(s)</div>
        <div class="cell value" [innerHTML]="oaCompilanceDetails.service">
          {{ oaCompilanceDetails.service }}
        </div>
      </div>
      <div class="row">
        <div class="cell label">OA User ID Owner</div>
        <div class="cell value">
          <input
            [(ngModel)]="oaCompilanceDetails.oaEmail"
            [ngClass]="{ 'disabled-input': !oaUserIdEditable }"
            [readonly]="!oaUserIdEditable"
            style="width: 250px"
          />
        </div>
      </div>
      <div class="row">
        <div class="cell label">Permanent Repair WO</div>
        <div class="cell value">
          <p-dropdown
            [options]="oaCompilanceDetails.maxOrders"
            [(ngModel)]="oaCompilanceDetails.woNum"
            [autoDisplayFirst]="true"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label">NAMO Date</div>
        <div class="cell value d-flex">
          <p-calendar
            [(ngModel)]="oaCompilanceDetails.namoDate"
            dateFormat="mm/dd/yy"
            [style]="{ width: '100%' }"
            [showIcon]="true"
          ></p-calendar>
          <p class="warningUser">
            NAMO Date cannot be deleted once entered, but it can be changed into
            the Future.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="cell label">Permanent Repair Date</div>
        <div class="cell value d-flex">
          <p-calendar
            [(ngModel)]="oaCompilanceDetails.permanentRepairDate"
            dateFormat="mm/dd/yy"
            [showIcon]="true"
          ></p-calendar>
          <p class="warningUser">
            Permanent Repair Date must be less than or equal NAMO Date.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="cell label">TLR Surveillance</div>
        <div class="cell value">
          <div>
          <p-dropdown
            class="inputFieldLength"
            [options]="TlrDropdownData"
            [(ngModel)]="oaCompilanceDetails.surveillance"
            styleClass="w-200"
          ></p-dropdown>
        </div>
        </div>
      </div>
      <div class="row">
        <div class="cell label">TLR Closure User ID</div>
        <div class="cell value d-flex">
          <input [(ngModel)]="oaCompilanceDetails.closureUserID" style="width: 250px;"/>
          <!-- <p class="warningUser mt-10 ml-10">Enter Closure Email Id</p> -->
        </div>
      </div>
      <div class="row">
        <div class="cell label">TLR Closure Date</div>
        <div class="cell value">
          <p-calendar
            [(ngModel)]="oaCompilanceDetails.closureDate"
            dateFormat="mm/dd/yy"
            [showIcon]="true"
          ></p-calendar>
        </div>
      </div>
      <div class="row">
        <div class="cell label">MOC WorkOrder No.</div>
        <div class="cell value d-flex">
          <input [(ngModel)]="oaCompilanceDetails.mocWorkOrderNumber" class="w-250" />

          <p-button
            icon="pi pi-search searchIcon"
            (click)="openMocOrderPopujp()"
            class="p-button-danger p-button-sm ml-10"
          >
          </p-button>
          <p class="SearchText mt-10 ml-10">Search MOC WorkOrder No.</p>
          <!-- <p class="error" *ngIf="errors">
            Invalid MOC WO. No., please search and select correct WO No.
          </p> -->
        </div>
      </div>
      <div class="row">
        <div class="cell label">OA Comments</div>
        <div class="cell value">
          <textarea [(ngModel)]="oaCompilanceDetails.comments" class="w-250"></textarea>
        </div>
      </div>
    </div>
    <div class="save-btncenter">
      <button (click)="saveDetails()" pButton class="cancel-btn h-15">Save</button>
    </div>

    <p-dialog
      [(visible)]="popupOpen"
      [header]="dialogTitle"
      [closable]="true"
      [style]="{ width: '80vw', height: '80vh' }"
    >
      <div>
        <div class="popUpHeader">
          <p>enter moc work order No.</p>
          <input
            type="text"
            class="cai-input"
            [(ngModel)]="mocWorkOrderNumber"
          />

          <p-button
            label="Search"
            (click)="searchMocWorkOrder()"
            class="p-button-danger p-button-sm"
          ></p-button>
        </div>
        <div class="popupData">
          <div *ngIf="mocWorkOrderList.length == 0">
            <p>No records to show</p>
          </div>
          <div *ngIf="mocWorkOrderList.length > 0">
            <p-table
              [value]="mocWorkOrderList"
              [scrollable]="true"
              scrollHeight="500px"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="RecID">Ref No</th>
                  <th pSortableColumn="MOCTitle">Moc Title</th>
                  <th pSortableColumn="MOCDescribe">MOC Describe</th>
                  <th pSortableColumn="WorkOrderNo">Work Order No</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{ row.RecID }}</td>
                  <td>{{ row.MOCTitle }}</td>
                  <td>{{ row.MOCDescribe }}</td>
                  <td class="link-underline" (click)="setWorkOrder(row)">
                    {{ row.WorkOrderNo }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </p-dialog>
  </div>
</div>
